define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,Controller,MessageDialog,xml) {

	return declare(Controller, {
		hasToConfirmAction: function() {
			// summary: no need to show confirmation dialog when no items (first time)
			return !!this.getNode().SOLineItems.length;
		},

        confirmAction: function(/*Object*/params) {
            // summary: do not allow action if none of the data packages has a PDF file
    		params = params || {};
    		params.buttons = [MessageDialog.BUTTON_UPDATE_BASELINE, MessageDialog.BUTTON_KEEP_CURRENT_BASELINE, MessageDialog.BUTTON_CANCEL];
    		this.inherited(arguments);
    	},

        onConfirm: function(/*String*/key) {
            // summary: set KeepBaseline to true if confirmed
			if (key == "C") {
				this.postProcess();
			} else {
	            this._bKeepBaseline = (key == MessageDialog.BUTTON_UPDATE_BASELINE);
	            this.preProcess();
			}
        },

        toWriterRequest: function() {
            // summary: add KeepBaseline boolean parameter to request
            return this.inherited(arguments).addParameter("KeepBaseline", xml.ATTR_BOOLEAN, this._bKeepBaseline);
        },

		postProcessSuccess: function() {
			// summary: refresh line-items view after creating line items
			var	view = this.widget.viewParent.getChildView("SOLineItems");
			if (view) {
				view.refreshWidget(true);
			}
		}
	});
});